import { parseSettingsTimestamp } from '@common/modules/settings/utils/parseSettingsTimestamp'

/**
 * Parses gateway dateCreated from the graft API (ISO string or unix seconds/ms) to epoch ms.
 */
export function parseGatewayDateCreated(value: string | null | undefined): number | null {
  return parseSettingsTimestamp(value)
}
